import { render, staticRenderFns } from "./LinkIcon.vue?vue&type=template&id=512ac570&scoped=true&"
import script from "./LinkIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./LinkIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512ac570",
  null
  
)

export default component.exports